module.exports = __webpack_public_path__ + "img/jdp.9d5139a0.png";